import { render, staticRenderFns } from "./OrderCustomerAll.vue?vue&type=template&id=7df56c72&"
import script from "./OrderCustomerAll.vue?vue&type=script&lang=ts&"
export * from "./OrderCustomerAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports